import { withInstall } from '@ll-plus/utils'

import ProgressBar from './src/progress-bar.vue'

export const LlProgressBar = withInstall(ProgressBar)

export * from './src/progress-bar'

declare module 'vue' {
  export interface GlobalComponents {
    LlProgressBar: typeof ProgressBar
  }
}
